import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Col, Row, Container, Card, Image, Stack } from "react-bootstrap";
import { Button } from "../../components/Formularios/Buttons/Button";
import InputSemBorda from "../../components/Formularios/Inputs/InputsSemBorda";
import logo from "../../assets/img/XC_Helpdesk.svg";
import { endpointPrincipal } from '../../api/endPoints/endpointPrincipal/endpointPrincipal';
import ValidaComplexidadeSenha from "../../components/Formularios/ValidaComplexidadeSenha";

export function RedefinirSenha() {
  const [senha, setSenha] = useState('');
  const [confirmSenha, setConfirmSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!token) {
      toast.error('Token de redefinição de senha inválido');
      return;
    }
    
    if (senha !== confirmSenha) {
      toast.error('As senhas não conferem');
      return;
    }

    try {
      setLoading(true);
      const response = await endpointPrincipal.post('/auth/redefinir-senha', {
        token,
        senha
      });

      if (response.status === 200) {
        toast.success('Senha redefinida com sucesso!');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (error: any) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Erro ao redefinir senha. O token pode ter expirado.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="mt-5">
      <Container>
        <Card>
          <div className="m-4">
            <Row>
              <Col sm={12} md={12} lg={6}>
                <Card
                  className="p-5 d-flex justify-content-center"
                  style={{ height: "95%" }}
                >
                  <Image
                    alt="XC Help Desk"
                    src={logo}
                    style={{ width: "100%", maxWidth: "360px", height: "auto", alignSelf: "center" }}
                  />
                </Card>
              </Col>
              <Col sm={12} md={12} lg={6}>
                <Card className="p-5">
                  <h3 className="text-center text-black">Redefinir Senha</h3>
                  {!token ? (
                    <div className="alert alert-danger mt-3">
                      Token de redefinição de senha inválido ou expirado.
                      Por favor, solicite uma nova redefinição de senha.
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <Row>
                        <Col sm={12} md={12} lg={12}>
                          <InputSemBorda
                            label="Nova Senha"
                            name="senha"
                            type="password"
                            placeholder="Digite sua nova senha"
                            value={senha}
                            onChange={setSenha}
                            required={true}
                            classNameInputsSemBorda="form-control bordasInferiorInput text-black"
                          />
                        </Col>
                      </Row>

                      <div className="mt-2">
                        <ValidaComplexidadeSenha senha={senha} />
                      </div>

                      <Row className="mt-3">
                        <Col sm={12} md={12} lg={12}>
                          <InputSemBorda
                            label="Confirmar Senha"
                            name="confirmarSenha"
                            type="password"
                            placeholder="Confirme sua nova senha"
                            value={confirmSenha}
                            onChange={setConfirmSenha}
                            required={true}
                            classNameInputsSemBorda="form-control bordasInferiorInput text-black"
                          />
                        </Col>
                      </Row>

                      <div className="mt-2">
                        <ValidaComplexidadeSenha senha={confirmSenha} />
                      </div>

                      <Stack gap={3} className="col-md-5 mx-auto">
                        <Button
                          className="mt-4 btn-info rounded-pill"
                          type="submit"
                          disabled={loading}
                          descricaoBotao={loading ? "Processando..." : "Redefinir Senha"}
                        />
                      </Stack>
                    </form>
                  )}
                </Card>
              </Col>
            </Row>
          </div>
          <Card className="rodape-login p-2 mt-3">
            <section className="d-flex justify-content-end">
              <p className="text-light px-3 fs-6">
                Copyright &copy; {new Date().getFullYear()}. Todos os direitos
                reservados XC Soluções.
              </p>
            </section>
          </Card>
        </Card>
      </Container>
    </main>
  );
} 